// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
  background-color: #092c36;
  color: #b8c5ca;
  font-family: "Roboto Bold", "Roboto", sans-serif;
  padding: 70px 44px 0;
}

.footer-main {
  display: grid;
  grid-template-columns: minmax(280px, 1fr) 180px 180px;
  gap: 36px;
}

.kc-div {
  margin: 0 0 22px;
  font-weight: 700;
  font-size: 29px;
  line-height: 1.25;
  color: #ffffff;
  font-family: "Roboto Bold", "Roboto", sans-serif;
}

.address-div {
  text-align: left;
  font-weight: 600;
  font-size: 22px;
  line-height: 1.75;
  color: #b8c5ca;
}

.footer[dir="rtl"] .address-div,
.footer[dir="rtl"] .kc-div,
.footer[dir="rtl"] .footer-links,
.footer[dir="rtl"] .copyright-div {
  text-align: right;
}

.footer[dir="rtl"] .footer-bottom {
  flex-direction: row-reverse;
}

.red-link {
  color: #ff6d6d;
  font-weight: 700;
  text-decoration: none;
}

.red-link:hover {
  color: #ffffff;
}

.footer-links {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.footer-links h2 {
  color: #d8e0e3;
  font-family: "Roboto Bold", "Roboto", sans-serif;
  font-size: 22px;
  font-weight: 800;
  letter-spacing: 2px;
  line-height: 1;
  margin: 0 0 8px;
  text-transform: uppercase;
}

.footer-links a {
  color: #b8c5ca;
  font-size: 22px;
  font-weight: 700;
  line-height: 1.2;
  text-decoration: none;
}

.footer-links a:hover {
  color: #ffffff;
}

.footer-bottom {
  align-items: center;
  border-top: 1px solid rgba(184, 197, 202, 0.2);
  display: flex;
  justify-content: space-between;
  margin-top: 54px;
  min-height: 94px;
}

.social-media-div {
  display: flex;
  gap: 14px;
}

.social-media-div a {
  align-items: center;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 10px;
  color: #ffffff;
  display: inline-flex;
  height: 52px;
  justify-content: center;
  text-decoration: none;
  width: 52px;
}

.social-media-div a:hover {
  background: rgba(255, 255, 255, 0.14);
}

.social-media-icon {
  color: #ffffff;
  font-size: 1.2em;
}

.copyright-div {
  font-family: "Roboto Bold", "Roboto", sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 19px;
  color: #8fa0a6;
  text-align: right;
}

@media (max-width: 900px) {
  .footer-main {
    grid-template-columns: 1fr 1fr;
  }

  .footer-contact {
    grid-column: 1 / -1;
  }

  .footer-bottom {
    align-items: flex-start;
    flex-direction: column;
    gap: 24px;
    padding: 28px 0;
  }

  .copyright-div {
    text-align: left;
  }
}

@media (max-width: 700px) {
  .footer {
    padding: 48px 24px 0;
  }

  .footer-main {
    grid-template-columns: 1fr;
  }

  .footer-bottom {
    padding-bottom: 28px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/footer.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,cAAc;EACd,gDAAgD;EAChD,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,qDAAqD;EACrD,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gDAAgD;AAClD;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;;;EAIE,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gDAAgD;EAChD,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,8CAA8C;EAC9C,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;EACrC,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,YAAY;EACZ,uBAAuB;EACvB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gDAAgD;EAChD,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;IACtB,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,oBAAoB;EACtB;AACF","sourcesContent":[".footer {\n  background-color: #092c36;\n  color: #b8c5ca;\n  font-family: \"Roboto Bold\", \"Roboto\", sans-serif;\n  padding: 70px 44px 0;\n}\n\n.footer-main {\n  display: grid;\n  grid-template-columns: minmax(280px, 1fr) 180px 180px;\n  gap: 36px;\n}\n\n.kc-div {\n  margin: 0 0 22px;\n  font-weight: 700;\n  font-size: 29px;\n  line-height: 1.25;\n  color: #ffffff;\n  font-family: \"Roboto Bold\", \"Roboto\", sans-serif;\n}\n\n.address-div {\n  text-align: left;\n  font-weight: 600;\n  font-size: 22px;\n  line-height: 1.75;\n  color: #b8c5ca;\n}\n\n.footer[dir=\"rtl\"] .address-div,\n.footer[dir=\"rtl\"] .kc-div,\n.footer[dir=\"rtl\"] .footer-links,\n.footer[dir=\"rtl\"] .copyright-div {\n  text-align: right;\n}\n\n.footer[dir=\"rtl\"] .footer-bottom {\n  flex-direction: row-reverse;\n}\n\n.red-link {\n  color: #ff6d6d;\n  font-weight: 700;\n  text-decoration: none;\n}\n\n.red-link:hover {\n  color: #ffffff;\n}\n\n.footer-links {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.footer-links h2 {\n  color: #d8e0e3;\n  font-family: \"Roboto Bold\", \"Roboto\", sans-serif;\n  font-size: 22px;\n  font-weight: 800;\n  letter-spacing: 2px;\n  line-height: 1;\n  margin: 0 0 8px;\n  text-transform: uppercase;\n}\n\n.footer-links a {\n  color: #b8c5ca;\n  font-size: 22px;\n  font-weight: 700;\n  line-height: 1.2;\n  text-decoration: none;\n}\n\n.footer-links a:hover {\n  color: #ffffff;\n}\n\n.footer-bottom {\n  align-items: center;\n  border-top: 1px solid rgba(184, 197, 202, 0.2);\n  display: flex;\n  justify-content: space-between;\n  margin-top: 54px;\n  min-height: 94px;\n}\n\n.social-media-div {\n  display: flex;\n  gap: 14px;\n}\n\n.social-media-div a {\n  align-items: center;\n  background: rgba(255, 255, 255, 0.08);\n  border-radius: 10px;\n  color: #ffffff;\n  display: inline-flex;\n  height: 52px;\n  justify-content: center;\n  text-decoration: none;\n  width: 52px;\n}\n\n.social-media-div a:hover {\n  background: rgba(255, 255, 255, 0.14);\n}\n\n.social-media-icon {\n  color: #ffffff;\n  font-size: 1.2em;\n}\n\n.copyright-div {\n  font-family: \"Roboto Bold\", \"Roboto\", sans-serif;\n  font-style: normal;\n  font-weight: 700;\n  font-size: 19px;\n  color: #8fa0a6;\n  text-align: right;\n}\n\n@media (max-width: 900px) {\n  .footer-main {\n    grid-template-columns: 1fr 1fr;\n  }\n\n  .footer-contact {\n    grid-column: 1 / -1;\n  }\n\n  .footer-bottom {\n    align-items: flex-start;\n    flex-direction: column;\n    gap: 24px;\n    padding: 28px 0;\n  }\n\n  .copyright-div {\n    text-align: left;\n  }\n}\n\n@media (max-width: 700px) {\n  .footer {\n    padding: 48px 24px 0;\n  }\n\n  .footer-main {\n    grid-template-columns: 1fr;\n  }\n\n  .footer-bottom {\n    padding-bottom: 28px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
